import React, { useState, useEffect } from 'react';
import APP_COLOURS from '../../config/colors';

const StaffList = ({ 
  staff, 
  filteredStaff, 
  selectedStaff, 
  setSelectedStaff,
  searchQuery,
  setSearchQuery,
  mallFilter,
  setMallFilter,
  uniqueMalls,
  retailerFilter,
  setRetailerFilter,
  uniqueRetailers
}) => {
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isMobile = screenWidth < 768;

  return (
    <div className="rounded-xl overflow-hidden" style={{ backgroundColor: APP_COLOURS.BG2, border: `1px solid ${APP_COLOURS.BLUE}20` }}>
      <div
        className="flex-shrink-0"
        style={{
          backgroundColor: APP_COLOURS.BG2,
          borderBottom: `1px solid ${APP_COLOURS.BLUE}20`,
          padding: isMobile ? '8px 10px' : '10px 16px',
        }}
      >
        <div className={`flex items-center ${isMobile ? 'gap-2' : 'gap-3'}`}>
          {/* Title + count */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <h2 className={`font-semibold ${isMobile ? 'text-xs' : 'text-sm'}`} style={{ color: APP_COLOURS.TEXTCOLOR }}>Staff</h2>
            <span
              className="rounded-full font-medium"
              style={{
                fontSize: isMobile ? '9px' : '10px',
                padding: '1px 6px',
                backgroundColor: `${APP_COLOURS.BLUE}15`,
                color: APP_COLOURS.BLUE,
              }}
            >
              {filteredStaff.length}
            </span>
          </div>

          {/* Search */}
          <div className={`relative flex-1 ${isMobile ? 'min-w-0' : 'max-w-[220px]'}`}>
            <div className="absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none">
              <i className="fas fa-search" style={{ fontSize: '9px', color: APP_COLOURS.BG5 }}></i>
            </div>
            <input
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="block w-full rounded focus:outline-none transition-all duration-200"
              style={{
                backgroundColor: APP_COLOURS.BG,
                border: `1px solid ${APP_COLOURS.BLUE}20`,
                color: APP_COLOURS.TEXTCOLOR,
                fontSize: isMobile ? '10px' : '11px',
                padding: isMobile ? '4px 22px 4px 20px' : '5px 24px 5px 22px',
              }}
              onFocus={(e) => { e.target.style.borderColor = APP_COLOURS.BLUE; }}
              onBlur={(e) => { e.target.style.borderColor = `${APP_COLOURS.BLUE}20`; }}
            />
            {searchQuery && (
              <button onClick={() => setSearchQuery('')} className="absolute inset-y-0 right-0 pr-2 flex items-center">
                <i className="fas fa-times" style={{ fontSize: '9px', color: APP_COLOURS.BG5 }}></i>
              </button>
            )}
          </div>

          {/* Mall Filter */}
          {uniqueMalls.length > 0 && (
            <select
              value={mallFilter}
              onChange={(e) => setMallFilter(e.target.value)}
              className="rounded focus:outline-none cursor-pointer flex-shrink-0"
              style={{
                backgroundColor: mallFilter !== 'all' ? `${APP_COLOURS.BLUE}15` : APP_COLOURS.BG,
                border: `1px solid ${mallFilter !== 'all' ? APP_COLOURS.BLUE : `${APP_COLOURS.BLUE}20`}`,
                color: mallFilter !== 'all' ? APP_COLOURS.BLUE : APP_COLOURS.TEXTCOLOR,
                fontSize: isMobile ? '10px' : '11px',
                padding: isMobile ? '4px 4px' : '5px 6px',
              }}
            >
              <option value="all" style={{ backgroundColor: APP_COLOURS.BG2 }}>{isMobile ? 'Mall' : 'All Malls'}</option>
              {uniqueMalls.map(mall => (
                <option key={mall} value={mall} style={{ backgroundColor: APP_COLOURS.BG2 }}>{mall}</option>
              ))}
            </select>
          )}

          {/* Retailer Filter */}
          {uniqueRetailers.length > 0 && (
            <select
              value={retailerFilter}
              onChange={(e) => setRetailerFilter(e.target.value)}
              className="rounded focus:outline-none cursor-pointer flex-shrink-0"
              style={{
                backgroundColor: retailerFilter !== 'all' ? `${APP_COLOURS.BLUE}15` : APP_COLOURS.BG,
                border: `1px solid ${retailerFilter !== 'all' ? APP_COLOURS.BLUE : `${APP_COLOURS.BLUE}20`}`,
                color: retailerFilter !== 'all' ? APP_COLOURS.BLUE : APP_COLOURS.TEXTCOLOR,
                fontSize: isMobile ? '10px' : '11px',
                padding: isMobile ? '4px 4px' : '5px 6px',
              }}
            >
              <option value="all" style={{ backgroundColor: APP_COLOURS.BG2 }}>{isMobile ? 'Retailer' : 'All Retailers'}</option>
              {uniqueRetailers.map(retailer => (
                <option key={retailer} value={retailer} style={{ backgroundColor: APP_COLOURS.BG2 }}>{retailer}</option>
              ))}
            </select>
          )}

          {/* Clear */}
          {(searchQuery || mallFilter !== 'all' || retailerFilter !== 'all') && (
            <button
              onClick={() => { setSearchQuery(''); setMallFilter('all'); setRetailerFilter('all'); }}
              className="flex-shrink-0 rounded transition-all duration-200 flex items-center justify-center"
              style={{
                width: isMobile ? '22px' : '24px',
                height: isMobile ? '22px' : '24px',
                backgroundColor: APP_COLOURS.BG4,
                color: APP_COLOURS.PLACEHOLDER,
                fontSize: isMobile ? '9px' : '10px',
                border: 'none',
                cursor: 'pointer',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = APP_COLOURS.BG5; e.currentTarget.style.color = APP_COLOURS.TEXTCOLOR; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = APP_COLOURS.BG4; e.currentTarget.style.color = APP_COLOURS.PLACEHOLDER; }}
              title="Clear filters"
            >
              <i className="fas fa-times"></i>
            </button>
          )}
        </div>
      </div>
      
      {staff.length === 0 ? (
        <div className={`text-center ${isMobile ? 'p-6' : 'p-12'}`}>
          <div>
            <i className={`fas fa-users ${isMobile ? 'text-2xl mb-2' : 'text-3xl mb-4'}`} style={{ color: APP_COLOURS.BG5 }}></i>
            <p className={isMobile ? 'text-xs' : 'text-sm'} style={{ color: APP_COLOURS.PLACEHOLDER }}>No staff members assigned to you yet.</p>
          </div>
        </div>
      ) : filteredStaff.length === 0 ? (
        <div className={`text-center ${isMobile ? 'p-6' : 'p-12'}`}>
          <div>
            <i className={`fas fa-search ${isMobile ? 'text-2xl mb-2' : 'text-3xl mb-4'}`} style={{ color: APP_COLOURS.BG5 }}></i>
            <p className={isMobile ? 'text-xs' : 'text-sm'} style={{ color: APP_COLOURS.PLACEHOLDER }}>No staff members match your search.</p>
          </div>
        </div>
      ) : isMobile ? (
        /* Mobile: Card-based layout */
        <div className="overflow-y-auto" style={{ borderTop: `1px solid ${APP_COLOURS.BLUE}20`, maxHeight: '400px', padding: '8px' }}>
          <div className="space-y-2">
            {filteredStaff.map((member) => (
              <div 
                key={member.id} 
                onClick={() => setSelectedStaff(member)}
                className="rounded-lg p-2.5 cursor-pointer transition-all duration-150"
                style={{ 
                  backgroundColor: selectedStaff?.id === member.id ? APP_COLOURS.BG4 : APP_COLOURS.BG3,
                  border: `1px solid ${selectedStaff?.id === member.id ? APP_COLOURS.BLUE : APP_COLOURS.BG4}30`,
                }}
              >
                <div className="flex items-center">
                  <div className="h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `linear-gradient(to right, ${APP_COLOURS.BLUE}, #9333ea)` }}>
                    <span className="text-white font-medium text-[10px]">
                      {member.first_name?.[0]}{member.last_name?.[0]}
                    </span>
                  </div>
                  <div className="ml-2 flex-1 min-w-0">
                    <div className="text-[11px] font-medium truncate" style={{ color: APP_COLOURS.TEXTCOLOR }}>
                      {member.first_name} {member.last_name}
                    </div>
                    <div className="text-[9px] truncate" style={{ color: APP_COLOURS.PLACEHOLDER }}>
                      {member.mall?.title || 'N/A'} • {member.retailer?.title || 'N/A'}
                    </div>
                  </div>
                  <i className="fas fa-chevron-right text-[10px] ml-1" style={{ color: APP_COLOURS.PLACEHOLDER }}></i>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        /* Desktop: Table layout */
        <div className="overflow-x-auto" style={{ borderTop: `1px solid ${APP_COLOURS.BLUE}20`, maxHeight: '600px', overflowY: 'auto' }}>
          <table className="min-w-full" style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
            <thead className="sticky top-0 z-10" style={{ backgroundColor: APP_COLOURS.BG3 }}>
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider" style={{ color: APP_COLOURS.PLACEHOLDER }}>
                  Staff
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider" style={{ color: APP_COLOURS.PLACEHOLDER }}>
                  Mall
                </th>
                <th className="px-3 py-2 text-left text-xs font-medium uppercase tracking-wider" style={{ color: APP_COLOURS.PLACEHOLDER }}>
                  Retailer
                </th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: APP_COLOURS.BG3 }}>
              {filteredStaff.map((member) => (
                <tr 
                  key={member.id} 
                  onClick={() => setSelectedStaff(member)}
                  className="cursor-pointer transition-all duration-150"
                  style={{ 
                    borderBottom: `1px solid ${APP_COLOURS.BLUE}10`,
                    backgroundColor: selectedStaff?.id === member.id ? APP_COLOURS.BG4 : 'transparent',
                  }}
                  onMouseEnter={(e) => {
                    if (selectedStaff?.id !== member.id) {
                      e.currentTarget.style.backgroundColor = APP_COLOURS.BG3;
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (selectedStaff?.id !== member.id) {
                      e.currentTarget.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  <td className="px-3 py-2">
                    <div className="flex items-center">
                      <div className="h-8 w-8 rounded-full flex items-center justify-center flex-shrink-0" style={{ background: `linear-gradient(to right, ${APP_COLOURS.BLUE}, #9333ea)` }}>
                        <span className="text-white font-medium text-xs">
                          {member.first_name?.[0]}{member.last_name?.[0]}
                        </span>
                      </div>
                      <div className="ml-2 min-w-0">
                        <div className="text-xs font-medium truncate" style={{ color: APP_COLOURS.TEXTCOLOR }}>
                          {member.first_name} {member.last_name}
                        </div>
                        <div className="text-xs truncate" style={{ color: APP_COLOURS.PLACEHOLDER }}>{member.email}</div>
                      </div>
                    </div>
                  </td>
                  <td className="px-3 py-2 text-xs" style={{ color: APP_COLOURS.TEXTCOLOR }}>
                    {member.mall?.title || 'N/A'}
                  </td>
                  <td className="px-3 py-2 text-xs" style={{ color: APP_COLOURS.TEXTCOLOR }}>
                    {member.retailer?.title || 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default StaffList;

